import React, { Component, Fragment } from 'react';
import { NavLink } from "react-router-dom";

interface IProps {
    id: number;
    url: string;
}

export class UserChangeHistoryTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
                <ul className="nav nav-tabs mb-3" role="tablist">
                    <li className="nav-item">
                        <NavLink
                            to={"/user-change-history/detail/" + this.props.id}
                            className={this.props.url === "/user-change-history/detail/" ? "nav-link active" : "nav-link"}
                        >
                            <i className="fas fa-info-circle"></i>&nbsp;Detail
                        </NavLink>
                    </li>
                </ul>
            </Fragment>
        );
    }
}
